import { render, staticRenderFns } from "./param.vue?vue&type=template&id=0fb73f47"
import script from "./param.vue?vue&type=script&lang=js"
export * from "./param.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fb73f47')) {
      api.createRecord('0fb73f47', component.options)
    } else {
      api.reload('0fb73f47', component.options)
    }
    module.hot.accept("./param.vue?vue&type=template&id=0fb73f47", function () {
      api.rerender('0fb73f47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/param.vue"
export default component.exports